// Defensive parser for GET /api/admin/notifications (owned by the orders module). Accepts
// `{ items, unreadCount }`, `{ items, unread }` or a bare array; drops malformed rows and any
// link that isn't a same-app path (no //evil.com, no javascript:).

export interface Notification { id: string; kind: string; title: string; body: string; link: string | null; readAt: string | null; createdAt: string }
export interface NotificationFeed { items: Notification[]; unread: number; unavailable: boolean }

export function parseFeed(raw: unknown): NotificationFeed {
  const list = Array.isArray(raw) ? raw : raw && typeof raw === 'object' && Array.isArray((raw as any).items) ? (raw as any).items : []
  const items: Notification[] = list.filter((n: any) => n && typeof n === 'object' && typeof n.id === 'string').map((n: any) => ({
    id: n.id, kind: typeof n.kind === 'string' ? n.kind : 'info',
    title: typeof n.title === 'string' ? n.title : 'Notification', body: typeof n.body === 'string' ? n.body : '',
    link: typeof n.link === 'string' && /^\/(?![/\\])/.test(n.link) ? n.link : null,
    readAt: typeof n.readAt === 'string' ? n.readAt : n.read === true ? 'read' : null,
    createdAt: typeof n.createdAt === 'string' ? n.createdAt : new Date().toISOString(),
  }))
  const unreadField = raw && typeof raw === 'object' && !Array.isArray(raw) ? ((raw as any).unreadCount ?? (raw as any).unread) : undefined
  return { items, unread: typeof unreadField === 'number' ? unreadField : items.filter(i => !i.readAt).length, unavailable: false }
}

